import { history, useLocation } from '@umijs/max';
import { useEffect } from 'react';
import { isAccessibleAppPath, isMenuPathAllowed } from './permissionRegistry';
import type { ResolvedLayout } from './types';

/**
 * После смены позиции пользователь может остаться на URL, которого
 * в новом меню нет. Уводим на главную; старый /chat — на мониторинг.
 */
export function ForbiddenRouteRedirect({ layout }: { layout: ResolvedLayout }) {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (
      (pathname === '/chat' || pathname.startsWith('/chat/')) &&
      isMenuPathAllowed(layout, '/monitoring')
    ) {
      history.replace(`/monitoring${search}`);
      return;
    }
    if (!isAccessibleAppPath(layout, pathname)) {
      history.replace('/welcome');
    }
  }, [layout, pathname, search]);

  return null;
}
